import React, { useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Drawer from "@mui/material/Drawer";
import AddClient from "./AddClient";
import ConfirmBox from "../../UiComponents/ConfirmBox/ConfirmBox";
import DeleteImage from "../../../src/Resources/Images/delete_common.png";
import MasterCommonTable from "../../UiComponents/CommonTable/MasterCommonTable";
import { Divider } from "@mui/material";

import {
  AddIcon,
  SearchIcon,
  DeleteIcon,
  DoneOutlineIcon,
  NotInterestedIcon,
} from "../../Resources/Icons/icons";
import { GetClient, DeleteClient } from "../../Service/_index";
import { useEffect } from "react";

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const headCells = [
  {
    id: "name",
    placeMent: true,
    disablePadding: false,
    label: "Client Name",
    minWidth: "150px",
  },
  {
    id: "mobileNumber",
    placeMent: true,
    disablePadding: false,
    label: "Mobile",
    minWidth: "150px",
  },
  {
    id: "email",
    placeMent: true,
    disablePadding: false,
    label: "Email",
    minWidth: "150px",
  },
  {
    id: "password",
    placeMent: true,
    disablePadding: false,
    label: "Password",
    minWidth: "150px",
  },
  // {
  //   id: "onlinePolicyUserName",
  //   placeMent: true,
  //   disablePadding: false,
  //   label: "OP User Name",
  //   minWidth: "150px",
  // },
  // {
  //   id: "onlinePolicyPassword",
  //   placeMent: true,
  //   disablePadding: false,
  //   label: "OP Password",
  //   minWidth: "150px",
  // },
];

const Client = () => {
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [selectedData, setSelectedData] = React.useState({});
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [openConfirmBox, setOpenConfirmBox] = React.useState(false);
  const [client, setClient] = React.useState([]);
  const [openLoader, setOpenLoader] = useState(false);
  const [filter, setFilter] = useState({
    fn: (items) => {
      return items;
    },
  });
  const roleId = sessionStorage.getItem("roleId");
  const userId = sessionStorage.getItem("UserId");
  const [tableConfig, setTableConfig] = useState({
    isAction: true,
    isView: false,
    isEdit: true,
    isDelete: true,
    isSearch: true,
    isSwitch: false, // Assuming disable/enable is not needed for client yet, based on previous implementation
  });


  const visibleRows = React.useMemo(
    () =>
      stableSort(filter.fn(client), getComparator(order, orderBy)),
     // Pagination is handled by MasterCommonTable internally or can be sliced here if isServerSide is false
     // MasterCommonTable handles slicing if isServerSide=false
    [order, orderBy, page, rowsPerPage, filter, client]
  );
  
  const GetData = () => {
    // The Client page is for the SUPER_ADMIN only (see the guard below).
    if (roleId !== "SUPER_ADMIN") return;
    setOpenLoader(true);
    GetClient().then((res) => {
      setOpenLoader(false);
      // The super admin's own record is never listed here, so it cannot be
      // edited or deleted from this page by mistake.
      let data = (res?.data || []).filter((item) => item.roleId !== "SUPER_ADMIN");
      if (roleId !== "SUPER_ADMIN") {
        data = data.filter((item) => item._id === userId);
      }
      // Ensure name is present, fallback to client field if necessary
      const formattedData = data.map(item => ({
          ...item,
          name: item.name || item.client
      }));
      setClient(formattedData);
    });
  };

  useEffect(() => {
    GetData();
  }, []);

  const EditClientData = (row) => {
    setSelectedData(row);
    setOpenDrawer(true);
  };

  const CreateBranchData = () => {
    setSelectedData({});
    setOpenDrawer(true);
  };

  const DeleteClientData = (row) => {
    setOpenConfirmBox(true);
    setSelectedData(row);
  };

  const DeleteFunction = () => {
    DeleteClient(selectedData._id).then((res) => {
      GetData();
      setOpenConfirmBox(false);
    });
  };

  const onSearch = (e) => {
    let target = e.target;
    setFilter({
      fn: (items) => {
        if (target.value == "") return items;
        else
          return items.filter((el) => {
            const name = el.name || el.client || "";
            return `${name},${el.email},${el.mobileNumber}`
              .toLowerCase()
              .includes(target.value.toLowerCase());
          });
      },
    });
  };

  // Typing /client into the address bar must not open it for anyone else.
  if (roleId !== "SUPER_ADMIN") {
    return (
      <Grid container className="Master_Card_Container">
        <Grid item xs={12} sx={{ p: 3 }}>
          <Typography className="Master_Card_Tittle">
            Only the super admin can manage clients.
          </Typography>
        </Grid>
      </Grid>
    );
  }

  return (
    <>
      <Grid container className="Master_Card_Container">
        <Grid
          container
          alignItems={"center"}
          className="Master_Card_Sub_Container"
        >
          <Grid item xs={12} sm={6} md={6}>
            <Typography className="Master_Card_Tittle">Client</Typography>
          </Grid>
          {roleId === "SUPER_ADMIN" && (
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              className="d-flex justify-content-end"
            >
              <Button
                className="Master_Card_create_Button w-100"
                startIcon={
                  <AddIcon
                    sx={{
                      marginRight: "1.5px",
                    }}
                  />
                }
                onClick={() => CreateBranchData()}
              >
                Create
              </Button>
            </Grid>
          )}
        </Grid>
        <Grid item xs={12}>
          <Divider
            sx={{
              backgroundColor: "#EAECF0",
              borderWidth: 1,
            }}
          />
        </Grid>
        <Grid
          container
          alignItems={"center"}
          justifyContent={"space-between"}
          className="Master_Card_Sub_Container"
        >
          <Grid item xs={12} sm={6} />
          <Grid item xs={12} sm={4} md={3.1} mt={{ xs: 2, sm: 0, md: 0 }}>
             <Input
              focused="false"
              className="w-100 Master_Card_Input"
              id="standard-adornment-password"
              onChange={onSearch}
              disableUnderline={true}
              placeholder="Search Client"
              startAdornment={
                <InputAdornment position="start" sx={{ marginRight: "0px" }}>
                  <IconButton aria-label="toggle password visibility">
                    <SearchIcon
                      sx={{
                        fontSize: "20px",
                      }}
                    />
                  </IconButton>
                </InputAdornment>
              }
            />
          </Grid>
        </Grid>
        <MasterCommonTable
          tableConfig={tableConfig}
          data={visibleRows}
          columns={headCells}
          handleEdit={EditClientData}
          handleDelete={DeleteClientData}
          tableTotalCount={filter.fn(client)?.length || 0}
          loading={openLoader}
        />
      </Grid>

      <Drawer
        open={openDrawer}
        sx={{
          zIndex: 100,
        }}
        anchor="right"
        PaperProps={{
          sx: { width: { xs: "100%", sm: "100%" } },
        }}
      >
        {openDrawer ? (
          <AddClient
            title={selectedData._id ? "Edit" : "Create"}
            selectedData={selectedData}
            formType={selectedData._id ? "edit" : "add"}
            setOpenDrawer={setOpenDrawer}
            GetData={GetData}
          />
        ) : null}
      </Drawer>

      <ConfirmBox
        open={openConfirmBox}
        title="Delete"
        content="Are you sure you want to delete this?"
        subContent="This action cannot be undone. Once deleted, the data will be permanently removed from the system."
        img={DeleteImage}
        confirmButton={"Delete"}
        setOpenConfirmBox={setOpenConfirmBox}
        Function={DeleteFunction}
        icon={<DeleteIcon />}
        color={"error"}
      />
    </>
  );
};
export default Client;
